import { render, staticRenderFns } from "./yearApprove.vue?vue&type=template&id=cbdb3b7e&scoped=true"
import script from "./yearApprove.vue?vue&type=script&lang=js"
export * from "./yearApprove.vue?vue&type=script&lang=js"
import style0 from "./yearApprove.vue?vue&type=style&index=0&id=cbdb3b7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb3b7e",
  null
  
)

export default component.exports